import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';

const useAccessToken = (scopes) => {
    const { instance } = useMsal();
    const [accessToken, setAccessToken] = useState(null);

    useEffect(() => {
        const getToken = async () => {

            try {
                const activeAccount = instance.getActiveAccount();
                if (!activeAccount) {
                    throw new Error('No active accounts');
                }
                const response = await instance.acquireTokenSilent({
                    account: activeAccount,
                    scopes: scopes,
                });
                setAccessToken(response.accessToken);
            } catch (error) {
                console.error('Error obtaining access token:', error);
            }
        };

        getToken();
    }, [instance, scopes]);

    return accessToken;
};

export default useAccessToken;